import type { R2BReferralBrandEntity } from "../../entity_types/r2bReferralBrand";

export const r2b_referral_14: R2BReferralBrandEntity = {
  token: "r2b_referral_14",
  type: "r2bReferralBrand",
  name: "Summit Trading Co.",
  website: "summittrading.co",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
